import { useEffect } from "react";
import { HISTORY_STORAGE_KEY } from "../../config/constants";

export const usePersistHistory = (history) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      try {
        localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(history));
      } catch (error) {
        console.error("Error saving history to localStorage", error);
      }
    }
  }, [history]);
};
